import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import styles from './annotationItem.scss';
import { t } from '../../../services/i18nService';
import annotationService from '../../../services/AnnotationService';

const AUTOSAVE_TIMER = 8200; // ms

const NoteInput = ({ questionId, selector, focused, comment = '' }) => {
    const [note, setNote] = useState(comment);
    const [timeoutId, setTimeoutId] = useState(null);
    const textareaRef = useRef();

    useEffect(() => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        setTimeoutId(setTimeout(saveNote, AUTOSAVE_TIMER));
    }, [note]);

    useEffect(() => {
        if (focused) {
            textareaRef.current.focus();
        }
    }, [focused]);

    const setNoteValue = (event) => {
        setNote(event.target.value);
    };

    const saveNote = () => {
        annotationService.setNote(questionId, selector, note);
    };

    const finishEditing = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        saveNote();
    };

    return (
        <TextareaAutosize
            className={styles.annotationNote}
            rows={2}
            placeholder={t('annotations.commentPlaceholder')}
            aria-label={t('annotationItem.textInput.ariaLabelText')}
            value={note}
            onChange={setNoteValue}
            onBlur={finishEditing}
            ref={textareaRef}
        />
    );
};

NoteInput.propTypes = {
    comment: PropTypes.string,
    focused: PropTypes.bool.isRequired,
    questionId: PropTypes.number.isRequired,
    selector: PropTypes.array.isRequired,
};

export default NoteInput;
